import { render, staticRenderFns } from "./hallmark.vue?vue&type=template&id=6ca1188c&"
import script from "./hallmark.vue?vue&type=script&lang=js&"
export * from "./hallmark.vue?vue&type=script&lang=js&"
import style0 from "./hallmark.vue?vue&type=style&index=0&id=6ca1188c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports